export const toRGBA = (color) => {
  const { r, g, b, a } = color.rgb;

  return `rgba(${r}, ${g}, ${b}, ${a})`;
};
